import { useHasOpened } from '@atlassian/jira-software-onboarding-quickstart-has-opened/src/services/has-opened/index.tsx';

export const useCanShowQuickstartNudge = (): boolean => {
	const [{ hasOpened }] = useHasOpened();
	return hasOpened;
};
